export default "__VITE_ASSET__CV39vhpZ__"